import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import { defaultFixturesExportFieldNames } from "~pages/Fixtures/FixtureListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportFixtures = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();
  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultFixturesExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/fixtures/export`, {
        method: "POST",
        body,
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        notification.success({
          message: formatMessage({ id: "fixtures.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
